module.exports = __webpack_public_path__ + "img/interstellar-exchange.8c4e9417.jpg";